import React from 'react';

interface IDiscountProps {
	size?: string;
}

export const Discount = ({ size = '24' }: IDiscountProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				d="M2.54862 11.5265L2.54968 11.5254L11.1399 2.91377C11.1539 2.89972 11.1683 2.88608 11.1832 2.87289C11.7731 2.34802 12.5247 2.04051 13.3134 2.00124C13.3299 2.00041 13.3465 2 13.3631 2H19.1139C19.614 2 20.0937 2.19856 20.4474 2.55215C20.8012 2.90576 21 3.38544 21 3.88571V9.63396C21 9.65304 20.9995 9.67211 20.9984 9.69116C20.9535 10.4737 20.6484 11.2187 20.1315 11.808C20.1169 11.8245 20.1019 11.8406 20.0863 11.8562L11.4783 20.4501L11.4767 20.4518C11.1232 20.803 10.6452 21 10.1471 21C9.64897 21 9.17098 20.803 8.81756 20.4518L8.81546 20.4497L2.55072 14.1877L2.54862 14.1856C2.19728 13.8324 2 13.3544 2 12.8561C2 12.3577 2.19728 11.8798 2.54862 11.5265Z"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.5784 9.19994C14.5996 9.19994 13.8062 8.40685 13.8062 7.42852C13.8062 6.45019 14.5996 5.6571 15.5784 5.6571C16.5571 5.6571 17.3506 6.45019 17.3506 7.42852C17.3506 8.40685 16.5571 9.19994 15.5784 9.19994Z"
				stroke="#3D3D3D"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
